<script>
import {BTfoot} from "bootstrap-vue";

export default {
  extends: BTfoot
};
</script>